var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_1489",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_1489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.06422 18.2902C3.77404 18.2902 3.53079 18.192 3.33449 17.9957C3.13819 17.7994 3.04004 17.5562 3.04004 17.266C3.04004 16.9758 3.13819 16.7326 3.33449 16.5363C3.53079 16.34 3.77404 16.2418 4.06422 16.2418H15.3302C15.6204 16.2418 15.8637 16.34 16.06 16.5363C16.2563 16.7326 16.3544 16.9758 16.3544 17.266C16.3544 17.5562 16.2563 17.7994 16.06 17.9957C15.8637 18.192 15.6204 18.2902 15.3302 18.2902H4.06422ZM19.3245 16.5491L15.6375 12.862C15.4326 12.6572 15.3302 12.4182 15.3302 12.1451C15.3302 11.872 15.4326 11.633 15.6375 11.4282L19.3245 7.74111C19.5123 7.55334 19.7513 7.45946 20.0415 7.45946C20.3316 7.45946 20.5706 7.55334 20.7584 7.74111C20.9462 7.92888 21.04 8.16785 21.04 8.45804C21.04 8.74822 20.9462 8.9872 20.7584 9.17496L17.7883 12.1451L20.7584 15.1152C20.9462 15.303 21.04 15.542 21.04 15.8321C21.04 16.1223 20.9462 16.3613 20.7584 16.5491C20.5706 16.7368 20.3316 16.8307 20.0415 16.8307C19.7513 16.8307 19.5123 16.7368 19.3245 16.5491ZM4.06422 13.1693C3.77404 13.1693 3.53079 13.0711 3.33449 12.8748C3.13819 12.6785 3.04004 12.4353 3.04004 12.1451C3.04004 11.8549 3.13819 11.6117 3.33449 11.4154C3.53079 11.2191 3.77404 11.1209 4.06422 11.1209H12.2577C12.5479 11.1209 12.7911 11.2191 12.9874 11.4154C13.1837 11.6117 13.2819 11.8549 13.2819 12.1451C13.2819 12.4353 13.1837 12.6785 12.9874 12.8748C12.7911 13.0711 12.5479 13.1693 12.2577 13.1693H4.06422ZM4.06422 8.04836C3.77404 8.04836 3.53079 7.95021 3.33449 7.75391C3.13819 7.55761 3.04004 7.31437 3.04004 7.02418C3.04004 6.734 3.13819 6.49075 3.33449 6.29445C3.53079 6.09815 3.77404 6 4.06422 6H15.3302C15.6204 6 15.8637 6.09815 16.06 6.29445C16.2563 6.49075 16.3544 6.734 16.3544 7.02418C16.3544 7.31437 16.2563 7.55761 16.06 7.75391C15.8637 7.95021 15.6204 8.04836 15.3302 8.04836H4.06422Z",
    fill: "#454E58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerOpen);
export default __webpack_public_path__ + "static/media/hamburger-open.60d980afd8ad8aa86181b128948ce54c.svg";
export { ForwardRef as ReactComponent };